import subscriptions from './subscriptions';
import subscribers from './subscribers';
import { Dispatch } from 'vuex';

export default {
	namespaced: true,
	modules: {
		subscriptions,
		subscribers,
	},
	actions: {
		async fetchAll({ dispatch }: { dispatch: Dispatch }): Promise<void> {
			await Promise.all([
				dispatch('subscriptions/fetchSubscriptions'),
				dispatch('subscribers/fetchSubscribers'),
			]);
		},

		cleanAll({ dispatch }: { dispatch: Dispatch }): void {
			dispatch('subscriptions/cleanAll');
			dispatch('subscribers/cleanAll');
		},
	},
};
